import { OnInit, EventEmitter, Output, Input, Component } from '@angular/core';
import {
  ServicioResolucion0256Service, FiltrosResolucionSp2BodyEntity, FiltrosResolucionSp4BodyEntity,
  FiltrosResolucionSp6BodyEntity,
  FiltrosResolucionSp2ExcelEntity,
  FiltrosResolucionSp4ExcelEntity,
  FiltrosResolucionSp6ExcelEntity
} from 'src/app/services/servicio-resolucion0256.service';
import { FileService } from 'src/app/services/utils/file.service';
import { FechaService } from 'src/app/services/utils/fecha.service';
import { ExcelService } from 'src/app/services/utils/excel.service';
import { FiltrosResolucionEntity, EntidadEmpresarial } from 'src/app/services/servicio-resolucion0256.service';
import { SelectItem } from 'primeng/api';
import { Empresa, DatosBaseResolucionEntity } from 'src/app/services/servicio-resolucion0256.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-header-resolucion0256',
  templateUrl: './header-resolucion0256.component.html',
  styleUrls: ['./header-resolucion0256.component.css']
})
export class HeaderResolucion0256Component implements OnInit {
  canDownload: boolean; // Indicador que existe data
  loading: boolean;
  downloading: boolean;
  mensaje: String;
  mensajeError: string; // Mensaje de error
  fechaInicial: string;
  fechaFinal: string;

  empresa: string;
  empresas: Empresa[];
  empresasItem: SelectItem[] = [];
  empresasSelected: SelectItem[] = [];


  @Input() public codigoBaseDatos: string;
  @Input() public objectDataResolucionEntity: FiltrosResolucionSp2BodyEntity[]; // se utilizara para descargar la matriz en excel
  @Input() public objectDataResolucionSp4Entity: FiltrosResolucionSp4BodyEntity[];
  @Input() public objectDataResolucionsp6Entity: FiltrosResolucionSp6BodyEntity[];
  @Input() public objetoDatosEntity: DatosBaseResolucionEntity;
  @Input() public objetoFiltroEntity: FiltrosResolucionEntity;
  @Input() public objetoDataFiltroEntity: FiltrosResolucionSp2BodyEntity[];
  @Input() public uncoEntidad: number;
  @Output() filtrosSeleccionados: EventEmitter<FiltrosResolucionEntity>;
  @Output() entidadEmpresarial: EventEmitter<EntidadEmpresarial>;
  @Output() cargandoFiltros: EventEmitter<any>;

  constructor(private servicioResolucion0256: ServicioResolucion0256Service,
    private servicioArchivo: FileService,
    private servicioFecha: FechaService,
    private servicioExcel: ExcelService) {

    this.loading = true;
    this.filtrosSeleccionados = new EventEmitter();
    this.entidadEmpresarial = new EventEmitter();
    this.cargandoFiltros = new EventEmitter();
  }

  ngOnInit() {
    this.init();
  }

  init() {
    this.empresa = '-1';
    this.getEmpresa();
    this.getEntidadEmpresarial();

    if (this.objetoFiltroEntity && this.objetoFiltroEntity.fechaInicial > 0) {
      this.fechaInicial = this.servicioFecha.getInputValue(this.objetoFiltroEntity.fechaInicial);
    }

    if (this.objetoFiltroEntity && this.objetoFiltroEntity.fechaFinal > 0) {
      this.fechaFinal = this.servicioFecha.getInputValue(this.objetoFiltroEntity.fechaFinal);
    }

    if (this.objetoFiltroEntity && this.objetoFiltroEntity.empresa) {
      this.empresa = this.objetoFiltroEntity.empresa;
    }

    if (!this.empresas || this.empresas.length === 0) {
      this.getEmpresa();
      if (this.objetoFiltroEntity && this.objetoFiltroEntity.empresa) {
        this.empresa = String(this.objetoFiltroEntity.empresa);
      } else {
        this.empresa = '-1';
      }
    }
    if (this.fechaInicial && this.fechaFinal && this.empresa !== '0') {
      this.onGenerar();
    }
  }

  async getEmpresa() {
    try {
      const response = await this.servicioResolucion0256.getEmpresa(this.objetoDatosEntity.codigoBaseDatos);
      if (response != null) {
        response.subscribe((data: Empresa[]) => {
          this.empresas = data;
          this.loading = false;
          this.empresasItem = [];
          this.mensaje = 'Cargando...';
          data.forEach((empresaTemporal: Empresa) => {
            this.empresasItem.push({ label: empresaTemporal.descripcionCorta, value: empresaTemporal.unco });
          });

        }, (err: HttpErrorResponse) => {
          console.log('Error empresa', err);
          if (err.status === 500) {
            this.empresas = [];
            this.loading = false;
          } else {
            console.log(err);
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  async getEntidadEmpresarial() {
    try {
      const response = await this.servicioResolucion0256.getEntidadEmpresarial(this.objetoDatosEntity, this.uncoEntidad);
      if (response != null) {
        response.subscribe((data: any) => {

          const entidad: EntidadEmpresarial = {
            unco: data.unco,
            nombreEntidad: data.dscrpcn_entdd_emprsrl,
            nit: data.idntfccn_trbtra,
            direccion: data.drccn,
            telefono: data.tlfno_pbx,
          };
          this.entidadEmpresarial.emit(entidad);

        }, (err: HttpErrorResponse) => {
          console.log('Error sede', err);
          if (err.status === 500) {
            this.loading = false;
          } else {
            console.log('Error en datos entidad empresarial: ' + err);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  onGenerar() {
    const inicio = this.servicioFecha.getFecha(this.fechaInicial);
    const fin = this.servicioFecha.getFecha(this.fechaFinal);
    const obj: FiltrosResolucionEntity = {
      codigoBaseDatos: '',
      fechaInicial: 0,
      fechaFinal: 0,
      empresa: '',
    };

    if (inicio === null || inicio.getTime() === 0) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar la <strong>Fecha Inicial</strong>.');
    } else if (fin === null || fin.getTime() === 0) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar la <strong>Fecha Final</strong>.');
    } else if (this.empresasSelected.length === 0) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('Debe seleccionar el campo <strong>Empresas</strong>.');
    } else if (this.servicioFecha.compare(inicio, fin) === 1) {
      this.filtrosSeleccionados.emit(obj);
      this.mostrarMensaje('La <strong>Fecha Inicial</strong> debe ser menor o igual a la <strong>Fecha Final</strong>');
    } else {
      obj.fechaInicial = inicio.getTime();
      obj.fechaFinal = fin.getTime();
      obj.empresa = String(this.empresasSelected);
      this.objetoFiltroEntity = obj;
      this.canDownload = obj.fechaInicial > 0;
      this.filtrosSeleccionados.emit(obj);
    }
  }

  onDescargarExcel() {
    this.downloading = true;
    const datoBodySptipo2: FiltrosResolucionSp2BodyEntity[] = this.objectDataResolucionEntity;
    const datosExcelSpTipo2: FiltrosResolucionSp2ExcelEntity[] = [];

    if (datoBodySptipo2 && datoBodySptipo2.length > 0) {
      datoBodySptipo2.forEach((objetoTemporalDatos: FiltrosResolucionSp2BodyEntity) => {
        const temporalDatosExcel: FiltrosResolucionSp2ExcelEntity = {
          tipoDeRegistro: objetoTemporalDatos.tipoDeRegistro,
          consecutivo: objetoTemporalDatos.consecutivo,
          tipoDocumento: objetoTemporalDatos.tipoDocumento,
          numeroIdentificacion: objetoTemporalDatos.numeroIdentificacion,
          fechaNacimiento: objetoTemporalDatos.fechaNacimiento,
          sexo: objetoTemporalDatos.sexo,
          primerApellido: objetoTemporalDatos.primerApellido,
          segundoApellido: objetoTemporalDatos.segundoApellido,
          primerNombre: objetoTemporalDatos.primerNombre,
          segundoNombre: objetoTemporalDatos.segundoNombre,
          codigoEntidadAdministradora: objetoTemporalDatos.codigoEntidadAdministradora,
          tipoCita: objetoTemporalDatos.tipoCita,
          codigoServicio: objetoTemporalDatos.codigoServicio,
          descripcionCups: objetoTemporalDatos.descripcionCups,
          fechaSolicitudCita: objetoTemporalDatos.fechaSolicitudCita,
          citaAsignada: objetoTemporalDatos.citaAsignada,
          fechaCita: objetoTemporalDatos.fechaCita,
          fechaDeseadaUsuario: objetoTemporalDatos.fechaDeseadaUsuario,
          empresa: objetoTemporalDatos.empresa

        };
        datosExcelSpTipo2.push(temporalDatosExcel);
      });
      this.servicioExcel.exportAsExcelFile(datosExcelSpTipo2, 'Reporte Resolucion256 Tipo2', 'Resolucion256');
      this.downloading = false;
    } else {
      this.mostrarMensaje('No existen datos para descargar, verifique los filtros. De lo contrario contactese con su administrador');
      this.downloading = false;
    }

    const datosBodySpTipo4: FiltrosResolucionSp4BodyEntity[] = this.objectDataResolucionSp4Entity;
    const datosExcelTipo4: FiltrosResolucionSp4ExcelEntity[] = [];

    if (datosBodySpTipo4 && datosBodySpTipo4.length > 0) {
      datosBodySpTipo4.forEach((objetoTemporalDatos: FiltrosResolucionSp4BodyEntity) => {
        const temporalDatosExcel: FiltrosResolucionSp4ExcelEntity = {
          tipoDeRegistro: objetoTemporalDatos.tipoDeRegistro,
          tipoDocumento: objetoTemporalDatos.tipoDocumento,
          numeroIdentificacion: objetoTemporalDatos.numeroIdentificacion,
          fechaNacimiento: objetoTemporalDatos.fechaNacimiento,
          sexo: objetoTemporalDatos.sexo,
          primerApellido: objetoTemporalDatos.primerApellido,
          segundoApellido: objetoTemporalDatos.segundoApellido,
          primerNombre: objetoTemporalDatos.primerNombre,
          segundoNombre: objetoTemporalDatos.segundoNombre,
          codigoEntidadAdministradora: objetoTemporalDatos.codigoEntidadAdministradora,
          municipio: objetoTemporalDatos.municipio,
          codigoServicio: objetoTemporalDatos.codigoServicio,
          fechaAsignacion: objetoTemporalDatos.fechaAsignacion,
          fechaCita: objetoTemporalDatos.fechaCita,
          atribuible: objetoTemporalDatos.atribuible,
          noReprogramada: objetoTemporalDatos.noReprogramada
        };
        datosExcelTipo4.push(temporalDatosExcel);
      });
      this.servicioExcel.exportAsExcelFile(datosExcelTipo4, 'Reporte Resolucion256 Tipo4', 'Resolucion256');
      this.downloading = false;
    } else {
      this.mostrarMensaje('No existen datos para descargar, verifique los filtros. De lo contrario contactese con su administrador');
      this.downloading = false;
    }

    const datosBodySpTipo6: FiltrosResolucionSp6BodyEntity[] = this.objectDataResolucionsp6Entity;
    const datosExcelTipo6: FiltrosResolucionSp6ExcelEntity[] = [];

    if (datosBodySpTipo6 && datosBodySpTipo6.length > 0) {
      datosBodySpTipo6.forEach((objetoTemporalDatos: FiltrosResolucionSp6BodyEntity) => {
        const temporalDatosExcel: FiltrosResolucionSp6ExcelEntity = {
          tipoDeRegistro: objetoTemporalDatos.tipoDeRegistro,
          tipoDocumento: objetoTemporalDatos.tipoDocumento,
          numeroIdentificacion: objetoTemporalDatos.numeroIdentificacion,
          fechaNacimiento: objetoTemporalDatos.fechaNacimiento,
          sexo: objetoTemporalDatos.sexo,
          primerApellido: objetoTemporalDatos.primerApellido,
          segundoApellido: objetoTemporalDatos.segundoApellido,
          primerNombre: objetoTemporalDatos.primerNombre,
          segundoNombre: objetoTemporalDatos.segundoNombre,
          eapb: objetoTemporalDatos.eapb,
          fechaIngreso: objetoTemporalDatos.fechaIngreso,
          horaIngreso: objetoTemporalDatos.horaIngreso,
          fechaAtencion: objetoTemporalDatos.fechaAtencion,
          horaAtencion: objetoTemporalDatos.horaAtencion
        };
        datosExcelTipo6.push(temporalDatosExcel);
      });
      this.servicioExcel.exportAsExcelFile(datosExcelTipo6, 'Reporte Resolucion256 Tipo6', 'Resolucion0256');
      this.downloading = false;
    } else {
      this.mostrarMensaje('No existen datos para descargar, verifique los filtros. De lo contrario contactese con su administrador');
      this.downloading = false;
    }


  }
  mostrarMensaje(mensaje: string) {
    this.mensajeError = mensaje;
    setTimeout(() => {
      this.mensajeError = null;
    }, 5000);
  }

}
